/**
 * Created by Bob.Gear on 11/03/14.
 */
//------------------------------------------------------------------------
//  projectNameFilter Directive
//------------------------------------------------------------------------
angular.module("EICDataStream3.queryBuilder")
  .controller('projectNameFilterController', ['$scope', '$http', "$state",
    function ($scope, $http, $state) {
      $scope.componentName = "projectNameFilter";

      $scope.resetFilter = function () {
        $scope.clearProjectName();
      };

      $scope.clearProjectName = function () {
        delete $scope.criteria["projectName"];
      };

      $scope.removeProjectNameFilter = function () {
        $scope.resetFilter();
        $scope.$parent.removeFilter("#projectNameFilter");
      };

      //----------  Project Name autocomplete function  ----------------------------
      var search = function (request, response) {

        var callback = function (r) {
          let data = r.data;
          var list = [];
          for (var i = 0; i < data.length; i++) {
            var thisItem = {
              label: data[i].name,
              value: data[i].name
            };

            list.push(thisItem);
          }
          response(data);
        };

        $http.get("/api/projectnamesuggestions?limit=11&q=" + JSON.stringify($scope.criteria))
          .then(callback)
          .catch(function (data, status, headers, config) {
            // called asynchronously if an error occurs
            // or server returns response with an error status.
          });
      },

        _renderItem = function (ul, item) {
          var itemName = (item.name.length > 50) ? item.name.substring(0, 49) + "&hellip;" : item.name;
          if (ul.children().length < 10) {
            return $("<li class='ui-menu-item' role='presentation'>")
              .data("item.autocomplete", item)

              //  .append("<a class='ui-corner-all'><div>" + trackingStatusIcon(item.trackingStatusID) + "&nbsp;<span  tabindex='-1'>" + item.name + "</span></div></a>")
              .append("<a class='ui-corner-all'><span  tabindex='-1'>" + itemName + "</span></a>")


              // .append("<div>" + trackingStatusIcon(item.trackingStatusID) + "<a class='ui-corner-all'  style='display:inline' tabindex='-1'>" + item.name + "</a></div>")
              //  .append(trackingStatusIcon(item.trackingStatusID) + "<a class='ui-corner-all'  style='display:inline' tabindex='-1'>" + item.name + "</a>")
              .appendTo(ul);
          }
          else {
            return $("<li class='divider' ></li><li class='ui-menu-item' style=color:red;text-align:center;' role='presentation'>more results are available with a more specific search</li>")
              .appendTo(ul);
          }


        },

        select = function (event, ui) {
          if (ui.item) {
            $scope.criteria.projectName = ui.item.name;
            // $scope.$parent.formChanged();
            // close the criteria pane
            //$scope.$emit("DETAIL_PAGE_ACTIVATED", true);
            $scope.$parent.showFilterContainer = false;
            $state.go('search.project', { projectID: ui.item.projectID, projectName: ui.item.name.urlEncode() });
          }
        };

      $scope.autocompleteOptions = {
        minLength: 2,
        source: search,
        select: select,
        delay: 500,
        _renderItem: _renderItem
      };


      var trackingStatusIcon = function (trackingStatusID) {
        switch (trackingStatusID) {
          case 1: return "<i class='glyphicon glyphicon-flash'/>"; // Active
          case 3: return "<i class='glyphicon glyphicon-calendar'/>"; // Future
          case 4: return "<i class='glyphicon glyphicon-floppy-save'/>"; // Archived
          case 6: return "<i class='glyphicon glyphicon-ban-circle'/>"; // Cancelled

          //default: return "<i class='glyphicon glyphicon-list'/>";
        }
      };

      $scope.openProject = function (projectID, projectName) {
        // close the criteria pane

        // projectDataService.stateParams = $stateParams;
        $state.go('search.project', { projectID: projectID, projectName: projectName.urlEncode() });
      };
      //----------------------------------------------------------------------------

      // $viewContentLoaded and $destroy don't seem to apply to
      // Directive Controllers.
      //        $scope.$on('$viewContentLoaded', function () {
      //          // say hello to your new content here
      //          // BUT NEVER TOUCHES THE DOM FROM A CONTROLLER
      //        });
      //
      //        $scope.$on('$destroy', function () {
      //          // say goodbye to your controller here
      //          // release resources, cancel request...
      //        });
    }])
  .directive('projectNameFilter', ['$compile',
    function ($compile) {
      return {
        replace: true,  // replace the placeholder element with the template
        restrict: 'A',   // usage: <div project-name-filter />
        templateUrl: "../app-ds3/search/queryBuilder/filters/projectNameFilter.tmpl.html",

        link: function ($scope, iElement, iAttrs) {
          var txtProjectName = iElement.find('#txtProjectName')
          txtProjectName.attr('placeholder', txtProjectName.attr('placeholder-text'));
        },

        controller: 'projectNameFilterController'
      };
    }]);
//------------------------------------------------------------------------

